import { render, staticRenderFns } from "./invoicing.vue?vue&type=template&id=8588b99e&scoped=true&"
import script from "./invoicing.vue?vue&type=script&lang=js&"
export * from "./invoicing.vue?vue&type=script&lang=js&"
import style0 from "./invoicing.vue?vue&type=style&index=0&id=8588b99e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8588b99e",
  null
  
)

export default component.exports